const BRIDGE_GAS_LIMIT = 150000

export {
  BRIDGE_GAS_LIMIT
}
